import { IOrder as INexusOrder } from "~/graphql/queries/order/orderByName";
import { IOrder } from "~/graphql/queries/order/orderByNumberAndPostalCode";

export type Order = IOrder | INexusOrder;
export default (order: Order) =>
  "number" in order ? order.number : order.name;



// WEBPACK FOOTER //
// ./src/helpers/getOrderNumber.ts